import {createContext, useContext, useState} from "react";
import {useNavigate} from "react-router-dom";
import {useLocalStorage} from "../hooks/useLocalStorage";

const AuthContext = createContext();
const AuthProvider = ({children}) => {
    const [isLogged, setIsLogged] = useState(false);
    const navigate = useNavigate();
    const [user, setUser] = useLocalStorage("user", null);

    const login = async (data) => {
        setUser(data);
        navigate("/");
    };

    const logout = () => {
        setUser(null);
        navigate("/login", { replace: true });
    };

    return (
        <AuthContext.Provider value={{
            user,
            login,
            logout
        }}>
            {children}
        </AuthContext.Provider>
    )
}

export const useAuth = () => {
    return useContext(AuthContext);
};

export default AuthProvider;